import { CAREER } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight } from "lucide-react";

export const Career = () => (
  <section
    id="erfaring"
    data-testid="career-section"
    className="bg-[#f4f4f2] text-[#141414] py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-6 flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
          Erfaring
        </p>
        <h2 className="font-display font-light leading-[1.05] text-4xl md:text-5xl lg:text-6xl mb-16 md:mb-24 max-w-3xl">
          En karriere bygget på digital handel — hos brands i vækst.
        </h2>
      </Reveal>

      <div className="border-t border-[#141414]/10">
        {CAREER.map((job, i) => (
          <Reveal key={job.company + job.period} delay={0.04}>
            <div
              data-testid={`career-row-${i}`}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8 py-9 border-b border-[#141414]/10 hover:bg-[#141414]/[0.03] transition-colors duration-300"
            >
              <div className="lg:col-span-3 font-ui text-sm uppercase tracking-[0.16em] text-[#1f3d2b] lg:pt-2">
                {job.period}
              </div>
              <div className="lg:col-span-5">
                <h3 className="font-display text-3xl md:text-4xl leading-tight flex items-center gap-3">
                  {job.company}
                  {job.highlight && (
                    <ArrowUpRight
                      size={22}
                      className="text-[#bfbfba] group-hover:text-[#1f3d2b] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                    />
                  )}
                </h3>
                <p className="mt-1 font-ui text-sm text-[#6f6f6a]">{job.role}</p>
              </div>
              <div className="lg:col-span-4">
                <p className="font-ui text-sm md:text-base text-[#5a5a56] leading-relaxed">
                  {job.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
